import {
  CustomerCollectedDataStatus,
  CustomerCollectedDataType,
} from 'src/constants/customer/enums'
import { State } from '../reducers/types'
import { CustomerCollectedData, CustomerProfile } from 'src/interfaces/customer'
import dayjs from 'dayjs'
import { CustomerPaymentMethod } from 'src/interfaces/customer'

export const getCustomerProfile = (state: State): CustomerProfile | null =>
  state.customer.customerProfile

export const getCustomerOnboardingStepsCount = (state: State): number =>
  (state.customer.customerProfile?.collectedData?.length || 0) + 2

export const getIsCustomerOnboardingCustomerInformationCompleted = (state: State): boolean =>
  !!state.customer.customerProfile?.partnerInformation?.isCompleted

export const getIsCustomerOnboardingPaymentInformationCompleted = (state: State): boolean =>
  !!state.customer.customerProfile?.paymentInformation?.isCompleted

export const getCustomerOnboardingPaymentInformation = (
  state: State,
): CustomerPaymentMethod | null => state.customer.customerProfile?.paymentMethod || null

export const getIsCustomerOnboardingPaymentMethodCompleted = (state: State): boolean =>
  !!state.customer.customerProfile?.paymentMethod?.isCompleted

export const getIsCustomerCollectedDataCompleted = (state: State): boolean =>
  !!state.customer.customerProfile?.collectedData?.every(
    (data) => data.status !== CustomerCollectedDataStatus.Created,
  )

export const getIsCustomerOnboardingStarted = (state: State): boolean =>
  getIsCustomerOnboardingCustomerInformationCompleted(state) ||
  getIsCustomerOnboardingPaymentInformationCompleted(state) ||
  !!state.customer.customerProfile?.collectedData?.some(
    (data) => data.status !== CustomerCollectedDataStatus.Created,
  )

export const getNotCompletedCustomerOnboardingCollectDataTypes = (
  state: State,
): CustomerCollectedDataType[] =>
  state.customer.customerProfile?.collectedData
    ?.filter((item) => item.status === CustomerCollectedDataStatus.Created)
    .map((item) => item.type) || []

export const getNotCompletedCustomerOnboardingCollectDataIdByType =
  (type: CustomerCollectedDataType) =>
  (state: State): string | null =>
    state.customer.customerProfile?.collectedData?.find(
      (item) => item.status === CustomerCollectedDataStatus.Created && item.type === type,
    )?.id || null

export const getCompletedCustomerOnboardingCollectDataStepsByType =
  (type: CustomerCollectedDataType) =>
  (state: State): number =>
    state.customer.customerProfile?.collectedData?.filter(
      (item) => item.status !== CustomerCollectedDataStatus.Created && item.type === type,
    )?.length || 0

export const getCustomerProfileInsuranceStepIndexById =
  (id: string | null) =>
  (state: State): number => {
    if (!id) {
      return -1
    }

    const insuranceSteps = state.customer.customerProfile?.collectedData?.filter(
      (item) => item.type === CustomerCollectedDataType.Insurance,
    )

    return insuranceSteps?.findIndex((item) => item.id === id) || 0
  }

export const getCustomerCollectedDataById =
  (id: string | null) =>
  (state: State): CustomerCollectedData | null => {
    if (!id) {
      return null
    }

    return state.customer.customerProfile?.collectedData?.find((item) => item.id === id) || null
  }

export const getIsCustomerProfileHasExpiringSoonSteps = (state: State): boolean => {
  return (
    state.customer.customerProfile?.collectedData?.some(
      (item) =>
        dayjs(item.expiresAt).diff(dayjs(), 'day') <= 30 && dayjs(item.expiresAt).isAfter(dayjs()),
    ) || false
  )
}

export const getIsCustomerProfileHasExpiredSteps = (state: State): boolean => {
  return (
    state.customer.customerProfile?.collectedData?.some(
      (item) => item.status === CustomerCollectedDataStatus.Expired,
    ) || false
  )
}
